/**
 * Generated bundle index. Do not edit.
 */

export {DatePipesModule,DatePipe,DistanceBetweenDatesPipe,MaxDatePipe,MinDatePipe,DatePipeManager,DatePipeConfiguration,AgoPipeOptions} from './public_api';

export {DATE_PIPE_CONFIGURATION_TOKEN as ɵa} from './src/app/date-pipes/providers/date-pipe-manager';
export {TimeAgoPipe as ɵb} from './src/app/date-pipes/time-ago-pipe/time-ago-pipe';